import React from 'react'
import { connect } from 'react-redux';
import * as AppActions from '../actions/AppActions';
import CustomForm from './CustomForm'
import ReduxTextField from '../ReduxFormFields/ReduxTextField'
import LoginHeaderText from './LoginHeaderText'
import HeaderImage from './HeaderImage';
import LableWithLoader from './LabelWithLoader';
import CustomTextMessage from './CustomTextMessage';
import { BLUE } from '../constants/index';

import {
  required,
  mobile
} from '../utilities/fieldValidate'

function mapStateToProps(state) {
  return {
    isLoading: state.login.isLoading,
    hasError: state.login.hasError,
  };
}


class OTPLoginBox extends React.Component {

  submit = values => {
    //sending history object to saga for internal route change
    this.props.getHistory(this.props.history)

    let data = {
      mobile: values.mobile,
      type: 1
    }
    this.props.sendOTP(data)
  }

  componentWillUnmount() {
    //to reset the error and isLoading state
    this.props.resetState()
  }


  render() {
    let err = !this.props.isLoading ? this.props.hasError : null
    return (
      <div>
        <HeaderImage />
        <div className='container-fluid'>
          <CustomForm
            form_name='mobile_form'
            destroy={false}
            isLoading={this.props.isLoading}
            onSubmit={this.submit}
            err={err}
            label={
              <LableWithLoader
                text='Confirm'
                loader={this.props.isLoading}
              />
            }
          >
            <LoginHeaderText />
            <ReduxTextField
              name='mobile'
              type='tel'
              floatingLabelText='Your Phone number'
              maxLength='10'
              autoComplete='off'
              validate={[required, mobile]}
              autoFocus={true}
            />
          </CustomForm>
        </div>
      </div>
    );
  }

}

export default connect(mapStateToProps, {
  ...AppActions
})(OTPLoginBox);


// WEBPACK FOOTER //
// ./src/components/OTPLoginBox.js